<atom-loader [isLoading]="(isLoading$ | async) ?? false"></atom-loader>
<router-outlet></router-outlet>
